import { render, staticRenderFns } from "./studyTourOrderDet.vue?vue&type=template&id=3e36d30c&scoped=true"
import script from "./studyTourOrderDet.vue?vue&type=script&lang=js"
export * from "./studyTourOrderDet.vue?vue&type=script&lang=js"
import style0 from "./studyTourOrderDet.vue?vue&type=style&index=0&id=3e36d30c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36d30c",
  null
  
)

export default component.exports